const knisaMainEN = {
  "knisa_main_title": "Entry Documents",
  "knisa_main_search_placeholder": "Search document",
  "knisa_main_button_new": "Add entry",
}

const knisaCreatePageEN = {
  "knisa_create_page_title": "New entry",
  "knisa_create_page_title_ids": "Entry: {{id}}",
  "knisa_create_page_search_placeholder": "Search",
  "knisa_create_page_back": "Back",
  "knisa_create_page_addItem": "Add item",
  "knisa_create_page_editTitle_aria": "Edit entry title",
  "knisa_create_divide_modal_title": "Divide entry {{entry}}-{{detail}}",
  "knisa_create_pallets_modal_title": "Pallets — entry {{entry}}-{{detail}}",
}

const knisaCreateTitleModalEN = {
  "knisa_create_modal_title_title": "New entry",
  "knisa_create_modal_title_date": "Date",
  "knisa_create_modal_title_time": "Time",
  "knisa_create_modal_title_grower": "Grower",
  "knisa_create_modal_title_refference": "Reference",
  "knisa_create_modal_title_carNum": "Car number",
  "knisa_create_modal_title_carSelect": "Select car",
  "knisa_create_modal_title_carClear": "No car",
  "knisa_create_modal_title_driver": "Driver",
  "knisa_create_modal_title_warehouse": "Warehouse",
  "knisa_create_modal_title_teudaType": "Document type",
  "knisa_create_modal_title_remark": "Remark",
  "knisa_create_modal_title_saveTitle": "Create entry",
  "knisa_create_modal_title_continue": "Continue",
  "knisa_create_modal_title_referenceExistsForDate": "Reference already exists for {{date}}",
}

const knisaCreateProductModalEN = {
  "knisa_create_modal_product_title_create": "Add item to entry",
  "knisa_create_modal_product_title_edit": "Update item",
  "knisa_create_modal_product_externalEntry": "External entry number",
  "knisa_create_modal_product_externalPalletExists": "This number already exists",
  "knisa_create_modal_product_pallet": "Pallet",
  "knisa_create_modal_product_qty": "Quantity",
  "knisa_create_modal_product_product": "Item",
  "knisa_create_modal_product_size": "Size",
  "knisa_create_modal_product_package": "Package",
  "knisa_create_modal_product_weight": "Weight",
  "knisa_create_modal_product_price": "Price",
  "knisa_create_modal_product_detection": "Location",
  "knisa_create_modal_product_expiryDate": "Expiration Date",
  "knisa_create_modal_product_copy": "Copy",
  "knisa_create_modal_product_multiplier": "Multiplier",

  "knisa_create_modal_product_includeWeight": "Include weight",
  "knisa_create_modal_product_createButton": "Add item",
  "knisa_create_modal_product_createPallet": "Create pallet",
  "knisa_create_modal_product_readScale_aria": "Read weight from scale",
}

const knisaCreateElementEN = {
  "knisa_create_element_swipe_edit": "Update",
  "knisa_create_element_swipe_delete": "Delete",
  "knisa_create_element_swipe_divide": "Divide",
  "knisa_create_element_netto": "Net",
  "knisa_create_element_brutto": "Gross",
  "knisa_create_element_print_aria": "Print",
}

const knisaNotificationsEN = {
  "knisa_notification_printPalletSuccess": "Pallet {{num}} printed successfully",
  "knisa_notification_printEntrySuccess": "Entry {{num}} printed successfully",
  "knisa_create_mass_print_title": "Print stickers",
  "knisa_create_mass_print_message": "Are you sure you want to print all stickers at once?",
  "knisa_create_mass_print_confirm": "Print",
  "knisa_create_mass_print_printing": "Printing...",
  "knisa_notification_massPrintSuccess": "All stickers were printed successfully",
  "knisa_notification_growerHasNoProduct": "This supplier does not have the selected product",
  "knisa_notification_massPrintFailure": "One or more stickers failed to print - please retry",
  "knisa_notification_printEntryFailure": "Failed to print entry {{num}}",
  "knisa_notification_genericError": "Something went wrong",
  "knisa_notification_entryUpdated": "Entry updated successfully",
  "knisa_notification_referenceExists": "Reference already recorded on {{date}}",
  "knisa_notification_cannotDeletePicked": "Cannot delete an entry that was already picked",
  "knisa_notification_palletDeleted": "Pallet deleted successfully",
  "knisa_notification_entryDeleted": "Entry deleted successfully",
  "knisa_notification_cannotDivide": "Cannot divide",
}

export const knisaTranslationEN = {
  knisa: {
    ...knisaMainEN,
    ...knisaCreatePageEN,
    ...knisaCreateTitleModalEN,
    ...knisaCreateProductModalEN,
    ...knisaCreateElementEN,
    ...knisaNotificationsEN
  }
}